import React, { useEffect, useMemo, useState } from 'react';
import Dialog from '../../../components/ui/Dialog/Dialog';
import deleteUser from '../../../API/Manager/deletarUser';

export default function DeleteUserDialog({ open, user, onClose, onDeleted }) {
  const [saving, setSaving] = useState(false);
  const self = useMemo(() => {
    try {
      const me = JSON.parse(sessionStorage.getItem('user'));
      return me && (me.id === user?.id || me.user === user?.user);
    } catch { return false; }
  }, [user]);

  useEffect(() => {
    if (open) setSaving(false);
  }, [open]);

  const confirm = async () => {
    if (!user || saving) return;
    if (self) {
      alert('Você não pode deletar o usuário logado.');
      return;
    }
    setSaving(true);
    try {
      await deleteUser(user.id, user.user);
      onDeleted?.(user);
      onClose?.();
    } catch (e) {
      console.error(e);
      alert('Erro ao deletar usuário.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} title={user ? `Excluir usuário — ${user.name}` : 'Excluir usuário'}>
      <div style={{display:'flex', flexDirection:'column', gap:12}}>
        <p>
          Tem certeza que deseja excluir <b>{user?.name}</b> ({user?.user})?
          <br/>Essa ação é irreversível.
        </p>
        {self && <div style={{fontSize:12, color:'#b91c1c'}}>Atenção: não é possível excluir o usuário atualmente logado.</div>}

        <div className="dialog-actions">
          <button onClick={onClose} disabled={saving}>Cancelar</button>
          <button onClick={confirm} disabled={saving || self} style={{color:'#b91c1c', border:'1px solid #fca5a5'}}>
            {saving ? 'Excluindo...' : 'Excluir'}
          </button>
        </div>
      </div>
    </Dialog>
  );
}